/* eslint-disable max-len */
import React from 'react'
import ThreeDotsLoader from '../../../Components/LoadingDots'

const SubscribeModal = ({subscribeModal, setSubscribeModal, handleSubscription, threedotLoader,setThreedotLoader}) => {
    return (
        <div className={`modal fade fixed top-0 left-0 ${subscribeModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="subscribeToBulkOffer" tabIndex="-1" aria-labelledby="subscribeToBulkOffer" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:min-w-[468px] min-w-full px-3 mx-auto" style={{margin: 'auto'}}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current px-4">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[14px] rounded-t-md">
                        <h5 className="sm:text-xl text-lg font-semibold text-[#555259] text-center w-full" id="exampleModalScrollableLabel1">
                            Subscribe to Bulk Offer
                        </h5>
                        <button onClick={() => setSubscribeModal(false)} type="button" data-bs-dismiss="modal" aria-label="Close" className="absolute top-3.5 right-6">
                            <img src="/images/icon-close.svg" alt="icon"/>
                        </button>
                    </div>
                    <div className="modal-body relative pt-3.5 pb-4 text-center">
                        <p className="sm:text-base text-sm font-normal text-[#555259]">
                            Subscribing to this bulk offer requires you to achieve the necessary criteria within the specified time period in order to avail the fulfilment discount.
                        </p>
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-4 rounded-b-md -mx-1.5">
                        <div className="w-[40%] px-1.5">
                            <button onClick={() => setSubscribeModal(false)} type="button"className="border border-[#555259] bg-[#FFFFFF] text-base font-normal text-[#555259] px-2 w-full py-3 rounded-lg" data-bs-dismiss="modal" aria-label="Close">
                                Cancel
                            </button>
                        </div>
                        <div className="w-[60%] px-1.5">
                            <button disabled={threedotLoader} type="button" className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-2 w-full rounded-lg deactivate-BulkOffer" 
                                onClick={()=> {handleSubscription()}}
                                data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#successBulkOffer">
                                {threedotLoader ? <div className='ml-[109px]'><ThreeDotsLoader /></div>: 'Subscribe'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubscribeModal